import { createSlice } from "@reduxjs/toolkit";
import { getData } from "../../services";

const initialState = {
  accessData: null, // Initialize with a default value
};

export const accessSlice = createSlice({
  name: "accessDetails",
  initialState,
  reducers: {
    setAccessData: (state, action) => {
      state.accessData = action.payload;
    },
  },
});

export const { setAccessData } = accessSlice.actions;

// Corrected selector
export const stateSelector = (state) => state?.accessDetails?.accessData;

export const fetchAccessData = (euid) => async (dispatch) => {
  try {
    const res = await getData({
      endpoint: "Employee/GetEmployeeAccess",
      params: { employee_id: euid },
    });
    if (res) {
      dispatch(setAccessData(res?.data));
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
  }
};

export default accessSlice.reducer;
